import React, { useState, useRef } from 'react';
import DebouncedSearch from '../../../common/form/debounced-search';
import StatusPicker from "../../../common/form/status-picker";

const statusOptions = [
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
  { value: "draft", label: "Draft" },
];

function DiscountsSearch({ query, submit, updateSearch, clearSearch }) {
  function handleSubmit(e) {
    e.preventDefault();
  }

  return (
    <div className='mx-auto sm:px-6 lg:px-8'>
      <div className="flex items-center justify-between mt-4 mb-2">
        <h1 className="text-2xl font-bold">Discounts</h1>
        <form className='flex items-start gap-3' onSubmit={handleSubmit}>
          <DebouncedSearch
            placeholder={"Search by name"}
            query={query.name}
            update={(value) => {
              updateSearch('name', value);
            }}
          />
          <StatusPicker
            label="Select Status"
            value={query.state}
            onChange={(value) => {
              updateSearch('state', value);
            }}
            options={statusOptions}
          />
          <button className="h-[40px] shadow-sm bg-white border border-gray-400 text-gray-900 text-sm rounded-lg focus:ring-indigo-500 focus:border-indigo-500 block p-2.5 focus:border-indigo-500 sm:text-sm"
                  onClick={(e) => {
                    e.preventDefault();
                    clearSearch()
                  }}>
            Clear
          </button>
        </form>
      </div>
    </div>
  )
}

export default DiscountsSearch;